import {
  HomeOutlined,
  ReloadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate, useRouteError } from "react-router-dom";
import {
  forceApplicationReload,
  isChunkLoadError,
} from "../utils/lazyWithRetry";

export function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const isChunkError = isChunkLoadError(error);

  return (
    <main className="route-error-page">
      <div className="route-error-page__code">ERP / RECOVERY</div>
      <span className="route-error-page__icon">
        <WarningOutlined />
      </span>
      <h1>{isChunkError ? "页面版本刚刚更新" : "页面暂时无法打开"}</h1>
      <p>
        {isChunkError
          ? "当前标签页仍在使用旧资源，刷新后会自动切换到最新版本。"
          : "系统已保留当前会话，可以刷新重试或返回经营工作台。"}
      </p>
      <div className="route-error-page__actions">
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={forceApplicationReload}
        >
          刷新到最新版本
        </Button>
        <Button icon={<HomeOutlined />} onClick={() => navigate("/workspace")}>
          返回工作台
        </Button>
      </div>
      <small>云猫 ERP · 页面恢复中心</small>
    </main>
  );
}
